import React, { useEffect, useState } from 'react';
import {
  Background,
  Wrap,
  Header,
  CloseButton,
  Buttons,
  CommentForm,
  Content,
  CommentLabel,
  SubmitButton,
} from './styled';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';
import useUsersStore from '../../../../../hooks/useUsersStore';
import useModalStore from 'hooks/useModalStore';
import { NamedCommunityService } from 'services/named';

const ActionLayer = ({
  view,
  onClickClose,
  selectedUser,
  postCheerComment,
  postCheerCommentReport,
  getCheerCommentReport,
  report,
  getBlackList,
}) => {
  const { content, create_at, user } = selectedUser;
  const { nick, user_id } = user;
  const { id } = useParams();
  const userStore = useUsersStore();
  const modalStore = useModalStore();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!!user_id) {
      getCheerCommentReport(user_id, id);
    }
  }, [user_id]);

  const userCheck = () => {
    if (userStore.data.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return false;
    }
    if (!userStore.data.is_admin) {
      if (!userStore.data.certify.is_phone_certify) {
        modalStore.openAlertModal({
          message: '휴대폰 인증 후 사용이 가능 합니다.',
        });
        return false;
      }
    }
    return true;
  };

  const onClickReport = (reportType) => {
    if (userCheck()) {
      let param = {
        target_id: user_id,
        device: 'WEB_MOBILE',
        game_id: id,
        report_type: reportType,
      };
      postCheerCommentReport(param).then((res) => {
        if (res.status === 200) {
          // onClickClose();
        } else {
          modalStore.openAlertModal({
            message: res.data.message,
          });
        }
      });
    }
  };

  const onClickCommentReport = () => {
    if (userCheck()) {
      const type = '기타';

      NamedCommunityService.postCommentReport(type, selectedUser.content, selectedUser.id, user_id).then((res) => {
        if (res.code === 200) {
          // onClickClose();
          modalStore.openAlertModal({
            message: '신고가 접수되었습니다.',
          });
        } else {
          modalStore.openAlertModal({
            message: res.message,
          });
        }
      });
    }
  };

  const onClickBlack = () => {
    if (userCheck()) {
      if (window.confirm(`블랙리스트에 추가하시겠습니까?`)) {
        NamedCommunityService.blackAdd(userStore.data.id, nick).then((res) => {
          if (res.code === 200) {
            alert(`${nick}님이 블랙리스트에 등록되었습니다.`);
            onClickClose();
            getBlackList(userStore.data.id);
          } else {
            alert(res.message);
          }
        });
      }
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (text.length === 0) {
      alert('메세지 입력하세요.');
      return;
    }
    if (userStore.data.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return;
    }
    if (!userStore.data.is_admin) {
      if (!userStore.data.certify.is_phone_certify) {
        modalStore.openAlertModal({
          message: '휴대폰 인증 후 사용이 가능 합니다.',
        });
        return;
      }
    }

    if (window.sessionStorage.getItem('lastMessage') === text) {
      alert('반복된 메세지는 입력할 수 없습니다.');
      return;
    }

    let param = {
      content: text,
      device: 'WEB_MOBILE',
      homeAway: null,
      selectTeamId: null,
      parentContent: selectedUser.content,
      parentId: selectedUser.id,
      parentImagePath: selectedUser.image_path,
      parentMbNick: nick,
      parentUserId: selectedUser.user_id,
    };

    postCheerComment(param).then((res) => {
      if (res.status === 200) {
        setText('');
        window.sessionStorage.setItem('lastMessage', text);
        onClickClose();
      } else {
        modalStore.openAlertModal({
          message: res.data.message,
        });
      }
    });
  };

  return (
    <Background view={view} onClick={onClickClose}>
      >
      <Wrap
        view={view}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <Header>
          <h3>{nick}</h3>
          <CloseButton onClick={onClickClose} />
        </Header>
        <Buttons>
          <div>
            <button className={clsx('real', report.is_real && 'opacity')} onClick={() => onClickReport('REAL')}>
              진중
            </button>
          </div>
          <div>
            <button className={clsx('fake', report.is_fake && 'opacity')} onClick={() => onClickReport('FAKE')}>
              구중
            </button>
          </div>
          <div>
            <button
              className={clsx('crime', report.is_crime && 'opacity')}
              // onClick={() => onClickReport("CRIME")}
              onClick={onClickCommentReport}
            >
              신고
            </button>
          </div>
          <div>
            <button className={'black'} onClick={onClickBlack}>
              차단
            </button>
          </div>
        </Buttons>
        <CommentForm onSubmit={onSubmit}>
          <Content>
            <p>{create_at}</p>
            <div>{content}</div>
            <CommentLabel>
              <div>{`@${nick}님에게 답장`}</div>
              <input
                type='text'
                placeholder={'답글을 입력하세요.'}
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </CommentLabel>
            <SubmitButton type={'submit'} isActive={text !== ''} />
          </Content>
        </CommentForm>
      </Wrap>
    </Background>
  );
};

export default ActionLayer;
